interface JsonElement {
  [key: string]: any;
}

export const extractUniqueColorsFromJSON = (
  jsonString: string
): {
  backgroundColor: string[];
  color: string[];
  borderColor: string[];
} => {
  const jsonObject = JSON.parse(jsonString);

  function extractColors(
    obj: JsonElement,
    colors: {
      backgroundColor: Set<string>;
      color: Set<string>;
      borderColor: Set<string>;
    }
  ): void {
    if (typeof obj === 'object') {
      for (const key in obj) {
        if (key === 'backgroundColor' || key === 'color') {
          if (
            typeof obj[key] === 'string' &&
            obj[key].match(/^#[0-9a-fA-F]{6,8}$/)
          ) {
            colors[key].add(obj[key]);
          }
        } else if (key.endsWith('Color')) {
          if (
            typeof obj[key] === 'string' &&
            obj[key].match(/^#[0-9a-fA-F]{6,8}$/)
          ) {
            colors.borderColor.add(obj[key]);
          }
        } else if (typeof obj[key] === 'object') {
          extractColors(obj[key], colors);
        }
      }
    }
  }

  const colors: {
    backgroundColor: Set<string>;
    color: Set<string>;
    borderColor: Set<string>;
  } = {
    backgroundColor: new Set<string>(),
    color: new Set<string>(),
    borderColor: new Set<string>(),
  };

  extractColors(jsonObject, colors);

  const colorObject: {
    backgroundColor: string[];
    color: string[];
    borderColor: string[];
  } = {
    backgroundColor: Array.from(colors.backgroundColor),
    color: Array.from(colors.color),
    borderColor: Array.from(colors.borderColor),
  };

  return colorObject;
};
